import _useDidMount from 'hooks/useDidMount.js'

const _useAsyncDidMount = (fn = () => null) =>
	_useDidMount(() => (async () => await fn())())

export default _useAsyncDidMount
